export default __webpack_public_path__ + "static/media/image.74b5a891.svg";